import packageDetails from '../../../package.json';
import { optionalEnv, requireEnv } from './require-env';

type AppConfig = {
  appVersion: string;
  sentryDsn: string;
  bucketName: string;
  cloudfrontBaseUrl: string; // To download file from S3
  doubletickDataS3Bucket: string; // To Media files with token
  doubletickDataBaseURL: string;
};

const appConfig: AppConfig = {
  appVersion: packageDetails.version,
  sentryDsn: optionalEnv('REACT_APP_SENTRY_DSN'),
  bucketName: requireEnv('REACT_APP_S3_BUCKET_NAME'),
  cloudfrontBaseUrl: requireEnv('REACT_APP_CLOUDFRONT_BASE_URL'),
  doubletickDataS3Bucket: requireEnv('REACT_APP_DOUBLETICK_DATA_S3_BUCKET'),
  doubletickDataBaseURL: requireEnv('REACT_APP_DOUBLETICK_DATA_BASE_URL'),
};

export default appConfig;
